import { Component, Input, ViewEncapsulation, inject } from '@angular/core';
import { MesListesUiService } from '../../services/mes-listes-ui.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-carousel',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="titbas">
      <i class="far fa-lightbulb-on"></i> &nbsp;Bon à savoir
    </div>
    <div class="arrbasleft" (click)="prev()">
      <i class="fas fa-arrow-alt-left"></i>
    </div>
    <div class="arrbasright" (click)="next()">
      <i class="fas fa-arrow-alt-right"></i>
    </div>
    <div class="contslidebas">
      <div class="slidebas" [style.margin-left]="marginLeft + '%'">
        @for (item of items; track $index; let i = $index) {
          <div class="bas" [class]="'bas bas' + (i + 1)" [innerHTML]="item"
               (click)="onSlideClick($event)">
          </div>
        }
      </div>
    </div>
    <div class="contpucebas">
      @for (item of items; track $index; let i = $index) {
        <i [class]="i + 1 === current ? 'fas fa-circle' : 'far fa-circle'"
           [id]="'icbas' + (i + 1)"
           [attr.tag]="i + 1"
           (click)="goTo(i + 1)">
        </i>
        @if (i < items.length - 1) { &nbsp; }
      }
    </div>
  `,
})
export class DashboardCarouselComponent {
  @Input() items: string[] = [];

  private readonly router = inject(Router);
  private readonly mesListesUi = inject(MesListesUiService);

  current = 1;
  marginLeft = 0;

  prev(): void {
    if (this.current <= 1) return;
    this.current--;
    this.marginLeft += 100;
  }

  next(): void {
    if (this.current >= this.items.length) return;
    this.current++;
    this.marginLeft -= 100;
  }

  goTo(n: number): void {
    this.current = n;
    this.marginLeft = -((n - 1) * 100);
  }

  onSlideClick(e: Event): void {
    const target = e.target as HTMLElement;
    const closest = target.closest('[class*="linkbas"]') as HTMLElement | null;
    if (!closest) return;
    const cls = closest.className ?? '';
    if (cls.includes('linkbasGac')) {
      e.stopPropagation();
      this.router.navigateByUrl('/gerer-les-acces');
    } else if (cls.includes('linkbasMlc')) {
      e.stopPropagation();
      this.mesListesUi.open();
    } else if (cls.includes('linkbasHelp')) {
      e.stopPropagation();
      this.router.navigateByUrl('/aide');
    }
  }
}
